import { render, staticRenderFns } from "./AppHeaderCustom.vue?vue&type=template&id=f9ac1346"
import script from "./AppHeaderCustom.vue?vue&type=script&lang=js"
export * from "./AppHeaderCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports